import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import * as RecordRTC from 'recordrtc';
import { Options } from "recordrtc";
import { RecorderService } from "./record-audio.service";

@Component({
  selector: 'app-audio-recorder',
  templateUrl: './audio-recorder.component.html',
  styleUrls: ['./audio-recorder.component.scss'],
})
export class AudioRecorderComponent implements OnInit {
  public isRecording = false;
  public isRecorded = false;
  public recordedTime = 0;
  public isPaused = false;
  public recorder: RecordRTC;
  public file: File;
  private isCancelled: boolean = false;
  public isEdge = navigator.userAgent.indexOf('Edge') !== -1;
  public isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  @Output() public onRecordingStart: EventEmitter<void> = new EventEmitter();
  @Output() public onRecordingStop: EventEmitter<void> = new EventEmitter();
  @Output() public onRecordingSend: EventEmitter<File> = new EventEmitter();
  @Output() public onRecordingCancel: EventEmitter<void> = new EventEmitter();
  private recordingIntervalTimmer;

  constructor(private recordAudioService: RecorderService) {}

  ngOnInit(): void {
    if(typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices.getUserMedia) {
        alert('This browser does not supports WebRTC getUserMedia API.');

      if(!!navigator.mediaDevices.getUserMedia) {
          alert('This browser seems supporting deprecated getUserMedia API.');
      }
    }
  }

  public startRecording() {
    this.recordAudioService.startRecording().then(() => {
      this.isCancelled = false;
      this.isRecording = true;
      this.isPaused = false;
      this.onRecordingStart.emit();
      this.recordedTime = 0;
      this.recordingIntervalTimmer = setInterval(() => {
          this.recordedTime += 1000;
      }, 1000);
    });
    // navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      // this.isCancelled = false;
      // this.isRecording = true;
      // this.isPaused = false;
      // this.onRecordingStart.emit();
      // this.recordedTime = 0;
      // this.audioChunks = [];
      // this.audioRecorderSuccessCallback(stream);
      // this.recordingIntervalTimmer = setInterval(() => {
      //     this.recordedTime += 1000;
      // }, 1000);
    //   // this.recorder.addEventListener("dataavailable", (event) => {
    //   //   this.audioChunks.push(event.data);
    //   // });
    //   // this.recorder.addEventListener("stop", () => {
    //   //   this.onRecordingStop.emit();
    //   //   clearInterval(this.recordingIntervalTimmer);
    //   // });
    // }).catch((error) => {
    //   alert('Unable to capture your microphone.');
    // });
  }

  // public audioRecorderSuccessCallback(stream: MediaStream) {
  //   const options: Options = {
  //     type: "audio",
  //     mimeType: "audio/wav",
  //     // numberOfAudioChannels: this.isEdge? 1 : 2,
  //     // checkForInactiveTracks: true,
  //     // bufferSize: this.isSafari? 4096 : undefined,
  //     // sampleRate: this.isSafari? 44100 : undefined,
  //     // desiredSampRate: this.isSafari? 44100 : undefined,
  //     recorderType: RecordRTC.StereoAudioRecorder,
  //     timeSlice: 1000,
  //     ondataavailable: (blob: Blob) => {
  //       if(this.isCancelled) return;
  //       this.audioChunks.push(blob);
  //     },
  //   };
  //   this.recorder = new RecordRTC(stream, options);
  //   this.recorder.startRecording();
  //   this.isRecording = true;
  // }

  public stopRecording() {
    this.isRecording = false;
    this.isPaused = false;
    this.recordAudioService.stopRecording().then((audioFile) => {
      this.file = audioFile;
      this.onRecordingStop.emit();
      clearInterval(this.recordingIntervalTimmer);
    }).catch((error) => {
      alert('Unable to capture your microphone.');
    });
    // const audioFile = new File(this.recordAudioService.finishRecording(), 'audio.wav', {
    //   type: 'audio/wav'
    //   });
      
    // this.onRecordingSend.emit(audioFile);
    // this.recorder.stopRecording();
    // this.onRecordingStop.emit();
    // clearInterval(this.recordingIntervalTimmer);
  }
  public pauseRecording() {
    this.isPaused = true;
    this.recorder.pauseRecording();
  }
  public resumeRecording() {
    this.isPaused = false;
    this.recorder.resumeRecording();
  }

  public onSend(){
    // const audioFile = new File(this.recordAudioService.finishRecording(), 'audio.wav', {
    //   type: 'audio/wav'
    //   });
    //   this.onRecordingSend.emit(audioFile);
    this.onRecordingSend.emit(this.file);
      this.isRecording = false;
      this.recordedTime = 0;
      this.file = null;
  }

  public onCancel(){
    this.isCancelled = true;
    this.isRecording = false;
    this.recordedTime = 0;
    this.recordAudioService.cancelRecording();
    clearInterval(this.recordingIntervalTimmer);
    this.onRecordingCancel.emit();
    this.file = null;
  }

  formatTime(milliseconds: number): string {
    const mins = Math.floor(milliseconds / 60000);
    const secs = Math.floor((milliseconds % 60000) / 1000);
    // const mils = (milliseconds % 1000).toString().substr(0, 2);  // Get the first 2 digits of milliseconds
    return `${mins} min :${secs} sec`;
  }

}